import React, { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { Result } from 'antd';

import { useMutation } from '@tanstack/react-query';
import Spin from 'components/Spin';
import QueryString from 'query-string';
import { confirmationService } from 'services/ConfirmationService';
import Footer from 'v2/components/Shared/Footer';

const REDIRECT_DELAY_MS = 10_000;

const ModerateCoproducer = () => {
  const location = useLocation();
  const history = useHistory();
  const urlParams = useMemo(() => QueryString.parse(location.search), [location.search]);

  const status = urlParams.status === 'approved' ? 'Aprovado' : 'Reprovado';
  const hasValidParameters = Boolean(urlParams.k && urlParams.status);

  const { mutate, isPending, isError, isSuccess } = useMutation({
    mutationFn: confirmationService.changeCoproducerStatus,
    onSettled: () => {
      setTimeout(() => history.push('/login'), REDIRECT_DELAY_MS);
    }
  });

  useEffect(() => {
    if (!hasValidParameters) {
      history.push('/login');
      return;
    }

    mutate({ k: urlParams.k as string, status: urlParams.status as string });
  }, [urlParams.k, urlParams.status, history, mutate, hasValidParameters]);

  return (
    <div className='flex min-h-screen flex-col text-center'>
      <main className='flex-1'>
        {isPending && <Result status='info' icon={<Spin />} title='Aguarde, salvando alterações...' />}
        {isError && <Result status='error' title='Link inválido' />}
        {isSuccess && <Result status='success' title={`${status} com sucesso`} />}
      </main>
      <Footer />
    </div>
  );
};

export default ModerateCoproducer;
